import Script from 'next/script';
import styles from './TrustedShopWidget.module.scss';

const TrustedShopWidget = () => {
  return (
    <>
      <Script
        strategy="lazyOnload"
        src="https://integrations.etrusted.com/applications/widget.js/v2"
      />
      <div
        className={styles.base}
        dangerouslySetInnerHTML={{
          __html:
            '<etrusted-widget data-etrusted-widget-id="wdg-aaba50d0-6253-4f37-a4e4-c5e10cea7b28" />',
        }}
      />
    </>
  );
};

export default TrustedShopWidget;
